import { firstInBurst, notResponseToClosed } from './filters'

export const averageResponseTime = {
  analysisType: 'average',
  eventCollection: 'message.sent',
  filters: [firstInBurst, notResponseToClosed],
  key: 'averageResponseTime',
  targetProperty: 'time.since_first_last_message_received',
}
